import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { Col, Row } from "antd"
import SearchFilterComponent from "../../../common/filters/SearchFilterComponent"
import LocationsSelectFilterComponent from "../../../common/filters/LocationsSelectFilterComponent"
import StatusFilterComponent from "../../../common/filters/StatusFilterComponent"
import type { FiltersIdentifier } from "../../../filters/types"
import { GLOBAL_FILTER_IDENTIFIER } from "../../../filters/reducer"
import AgendaHeadingPanelLegacy from "../../../common/AgendaHeadingPanelLegacy"
import { ReportTitle } from "../../../common/ReportTitle"
import FigureVsMakeItButterOrdersFilter from "../orders/components/FigureVsMakeItButterOrdersFilter"
import { KBLinkProp } from "../../../uiKit/KBLink/KBLink"

type Props = {
    showLocationFilter: boolean
    showSearchFilter: boolean
    identifier: FiltersIdentifier
    headerText: string
    showSalesByItemsViewFilter: boolean
    showOrderStatusFilter?: boolean
    showOrderSourceFilter?: boolean
    showRangePicker: boolean
    showDownloadButton: boolean
    haveData: boolean
    showReportTitle?: boolean
    salesByItemsViewFilterComponent?: Maybe<React.ReactElement<any>>
    kbLink?: KBLinkProp
}
type State = {
    window: {
        width: number
        height: number
    }
}

class ReportHeadingPanel extends React.PureComponent<Props, State> {
    static defaultProps = {
        showLocationFilter: true,
        showSearchFilter: true,
        showRangePicker: true,
        showDownloadButton: true,
        showSalesByItemsViewFilter: false,
        showOrderStatusFilter: false,
        showOrderSourceFilter: false,
        haveData: false,
        showReportTitle: true,
        salesByItemsViewFilterComponent: null,
    }

    render() {
        return (
            <div>
                {this.props.showReportTitle && (
                    <ReportTitle
                        showRangePicker={this.props.showRangePicker}
                        showDownloadButton={this.props.showDownloadButton}
                        identifier={this.props.identifier}
                        haveData={this.props.haveData}
                        kbLink={this.props.kbLink}>
                        {this.props.headerText}
                    </ReportTitle>
                )}
                <AgendaHeadingPanelLegacy>
                    <Row>
                        <Col span={20}>
                            <Row type="flex">
                                {this.props.showLocationFilter && (
                                    <LocationsSelectFilterComponent
                                        identifier={GLOBAL_FILTER_IDENTIFIER}
                                        style={{
                                            marginRight: "1rem",
                                        }}
                                    />
                                )}
                                {this.props.showOrderStatusFilter && <StatusFilterComponent identifier="orders" />}
                                {this.props.showOrderSourceFilter && (
                                    <FigureVsMakeItButterOrdersFilter
                                        identifier="orders"
                                        style={{
                                            marginLeft: "1rem",
                                        }}
                                    />
                                )}
                                {this.props.showSalesByItemsViewFilter
                                    ? this.props.salesByItemsViewFilterComponent
                                    : null}
                            </Row>
                        </Col>
                        <Col span={4}>
                            <Row
                                type="flex"
                                justify="end"
                                style={{
                                    flexWrap: "nowrap",
                                }}>
                                {this.props.showSearchFilter && (
                                    <SearchFilterComponent identifier={this.props.identifier} placeholder="Search" />
                                )}
                            </Row>
                        </Col>
                    </Row>
                </AgendaHeadingPanelLegacy>
            </div>
        )
    }
}

export default ReportHeadingPanel
